@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-47_590_960)
internal val Res.string.operational_detailed_summary_title: StringResource by lazy {
      StringResource("string:operational_detailed_summary_title", "operational_detailed_summary_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36952, 78),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.operational_detailed_total: StringResource by lazy {
      StringResource("string:operational_detailed_total", "operational_detailed_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37166, 42),
      ))
    }

@delegate:ResourceContentHash(2_032_286_178)
internal val Res.string.operational_detailed_total_planned: StringResource by lazy {
      StringResource("string:operational_detailed_total_planned", "operational_detailed_total_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37031, 74),
      ))
    }

@delegate:ResourceContentHash(1_715_204_180)
internal val Res.string.operational_detailed_total_real: StringResource by lazy {
      StringResource("string:operational_detailed_total_real", "operational_detailed_total_real", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37106, 59),
      ))
    }

@delegate:ResourceContentHash(403_999_759)
internal val Res.string.operational_detailed_weekly_title: StringResource by lazy {
      StringResource("string:operational_detailed_weekly_title", "operational_detailed_weekly_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37209, 69),
      ))
    }

@delegate:ResourceContentHash(1_348_282_933)
internal val Res.string.operational_directors_empty: StringResource by lazy {
      StringResource("string:operational_directors_empty", "operational_directors_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37279, 75),
      ))
    }

@delegate:ResourceContentHash(1_814_593_307)
internal val Res.string.operational_discard_confirm: StringResource by lazy {
      StringResource("string:operational_discard_confirm", "operational_discard_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37355, 47),
      ))
    }

@delegate:ResourceContentHash(-1_133_326_709)
internal val Res.string.operational_discard_message: StringResource by lazy {
      StringResource("string:operational_discard_message", "operational_discard_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37403, 95),
      ))
    }

@delegate:ResourceContentHash(1_346_171_783)
internal val Res.string.operational_discard_title: StringResource by lazy {
      StringResource("string:operational_discard_title", "operational_discard_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37499, 65),
      ))
    }

@delegate:ResourceContentHash(-723_983_358)
internal val Res.string.operational_edit_hint: StringResource by lazy {
      StringResource("string:operational_edit_hint", "operational_edit_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37565, 113),
      ))
    }

@delegate:ResourceContentHash(-1_705_183_757)
internal val Res.string.operational_edit_mode: StringResource by lazy {
      StringResource("string:operational_edit_mode", "operational_edit_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37679, 53),
      ))
    }

@delegate:ResourceContentHash(594_811_985)
internal val Res.string.operational_edit_window_info: StringResource by lazy {
      StringResource("string:operational_edit_window_info", "operational_edit_window_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37733, 128),
      ))
    }

@delegate:ResourceContentHash(1_875_234_112)
internal val Res.string.operational_entries_select_unit_required: StringResource by lazy {
      StringResource("string:operational_entries_select_unit_required", "operational_entries_select_unit_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37862, 96),
      ))
    }

@delegate:ResourceContentHash(-1_335_978_275)
internal val Res.string.operational_entries_title: StringResource by lazy {
      StringResource("string:operational_entries_title", "operational_entries_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37959, 49),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.operational_entries_unit_label: StringResource by lazy {
      StringResource("string:operational_entries_unit_label", "operational_entries_unit_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38009, 50),
      ))
    }

@delegate:ResourceContentHash(-338_786_840)
internal val Res.string.operational_entries_unit_placeholder: StringResource by lazy {
      StringResource("string:operational_entries_unit_placeholder", "operational_entries_unit_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38060, 72),
      ))
    }

@delegate:ResourceContentHash(195_857_569)
internal val Res.string.operational_expense_estivas: StringResource by lazy {
      StringResource("string:operational_expense_estivas", "operational_expense_estivas", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38133, 47),
      ))
    }

@delegate:ResourceContentHash(1_697_940_019)
internal val Res.string.operational_expense_gas: StringResource by lazy {
      StringResource("string:operational_expense_gas", "operational_expense_gas", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38181, 39),
      ))
    }

@delegate:ResourceContentHash(234_542_413)
internal val Res.string.operational_expense_hortifruti: StringResource by lazy {
      StringResource("string:operational_expense_hortifruti", "operational_expense_hortifruti", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38221, 54),
      ))
    }

@delegate:ResourceContentHash(1_164_145_288)
internal val Res.string.operational_expense_laticinios: StringResource by lazy {
      StringResource("string:operational_expense_laticinios", "operational_expense_laticinios", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38276, 54),
      ))
    }

@delegate:ResourceContentHash(7_099_573)
internal val Res.string.operational_expense_nao_alimentar_central: StringResource by lazy {
      StringResource("string:operational_expense_nao_alimentar_central", "operational_expense_nao_alimentar_central", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38331, 81),
      ))
    }

@delegate:ResourceContentHash(66_562_623)
internal val Res.string.operational_expense_nao_alimentar_operacao: StringResource by lazy {
      StringResource("string:operational_expense_nao_alimentar_operacao", "operational_expense_nao_alimentar_operacao", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38413, 86),
      ))
    }

@delegate:ResourceContentHash(1_864_398_635)
internal val Res.string.operational_expense_padarias: StringResource by lazy {
      StringResource("string:operational_expense_padarias", "operational_expense_padarias", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38500, 48),
      ))
    }

@delegate:ResourceContentHash(-1_430_148_326)
internal val Res.string.operational_expense_proteinas: StringResource by lazy {
      StringResource("string:operational_expense_proteinas", "operational_expense_proteinas", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38549, 53),
      ))
    }

@delegate:ResourceContentHash(1_064_633_051)
internal val Res.string.operational_expense_sucos_bebidas: StringResource by lazy {
      StringResource("string:operational_expense_sucos_bebidas", "operational_expense_sucos_bebidas", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38603, 61),
      ))
    }

@delegate:ResourceContentHash(852_374_094)
internal val Res.string.operational_export_success: StringResource by lazy {
      StringResource("string:operational_export_success", "operational_export_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38665, 66),
      ))
    }

@delegate:ResourceContentHash(-1_442_843_430)
internal val Res.string.operational_export_unavailable: StringResource by lazy {
      StringResource("string:operational_export_unavailable", "operational_export_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38732, 106),
      ))
    }

@delegate:ResourceContentHash(468_656_504)
internal val Res.string.operational_history_empty: StringResource by lazy {
      StringResource("string:operational_history_empty", "operational_history_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38839, 65),
      ))
    }

@delegate:ResourceContentHash(1_854_018_742)
internal val Res.string.operational_history_rejected: StringResource by lazy {
      StringResource("string:operational_history_rejected", "operational_history_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38905, 80),
      ))
    }

@delegate:ResourceContentHash(168_171_887)
internal val Res.string.operational_history_saved: StringResource by lazy {
      StringResource("string:operational_history_saved", "operational_history_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38986, 65),
      ))
    }

@delegate:ResourceContentHash(1_208_468_019)
internal val Res.string.operational_history_title: StringResource by lazy {
      StringResource("string:operational_history_title", "operational_history_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39052, 49),
      ))
    }

@delegate:ResourceContentHash(-1_831_547_343)
internal val Res.string.operational_launch_gestao_financeira: StringResource by lazy {
      StringResource("string:operational_launch_gestao_financeira", "operational_launch_gestao_financeira", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39102, 68),
      ))
    }

@delegate:ResourceContentHash(1_744_121_179)
internal val Res.string.operational_launch_provisionados_mes: StringResource by lazy {
      StringResource("string:operational_launch_provisionados_mes", "operational_launch_provisionados_mes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39171, 72),
      ))
    }

@delegate:ResourceContentHash(-956_166_343)
internal val Res.string.operational_launch_reclamacao_cliente: StringResource by lazy {
      StringResource("string:operational_launch_reclamacao_cliente", "operational_launch_reclamacao_cliente", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39244, 93),
      ))
    }

@delegate:ResourceContentHash(-578_749_321)
internal val Res.string.operational_launch_satisfacao_cliente: StringResource by lazy {
      StringResource("string:operational_launch_satisfacao_cliente", "operational_launch_satisfacao_cliente", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39338, 93),
      ))
    }

@delegate:ResourceContentHash(-987_606_314)
internal val Res.string.operational_maintenance_message: StringResource by lazy {
      StringResource("string:operational_maintenance_message", "operational_maintenance_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39432, 143),
      ))
    }

@delegate:ResourceContentHash(-842_496_771)
internal val Res.string.operational_managers_col_expense: StringResource by lazy {
      StringResource("string:operational_managers_col_expense", "operational_managers_col_expense", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39576, 60),
      ))
    }

@delegate:ResourceContentHash(1_048_661_689)
internal val Res.string.operational_managers_col_result: StringResource by lazy {
      StringResource("string:operational_managers_col_result", "operational_managers_col_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39637, 59),
      ))
    }

@delegate:ResourceContentHash(-862_941_664)
internal val Res.string.operational_managers_col_revenue: StringResource by lazy {
      StringResource("string:operational_managers_col_revenue", "operational_managers_col_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39697, 64),
      ))
    }

@delegate:ResourceContentHash(-1_344_459_005)
internal val Res.string.operational_managers_empty: StringResource by lazy {
      StringResource("string:operational_managers_empty", "operational_managers_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39762, 70),
      ))
    }

@delegate:ResourceContentHash(-13_251_827)
internal val Res.string.operational_managers_totals_caption: StringResource by lazy {
      StringResource("string:operational_managers_totals_caption", "operational_managers_totals_caption", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39833, 67),
      ))
    }

@delegate:ResourceContentHash(-2_018_291_616)
internal val Res.string.operational_no_company: StringResource by lazy {
      StringResource("string:operational_no_company", "operational_no_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39901, 90),
      ))
    }

@delegate:ResourceContentHash(-1_904_133_488)
internal val Res.string.operational_overview_employees: StringResource by lazy {
      StringResource("string:operational_overview_employees", "operational_overview_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39992, 58),
      ))
    }

@delegate:ResourceContentHash(-1_958_020_641)
internal val Res.string.operational_overview_empty: StringResource by lazy {
      StringResource("string:operational_overview_empty", "operational_overview_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40051, 74),
      ))
    }

@delegate:ResourceContentHash(1_863_124_316)
internal val Res.string.operational_overview_expense: StringResource by lazy {
      StringResource("string:operational_overview_expense", "operational_overview_expense", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40195, 52),
      ))
    }

@delegate:ResourceContentHash(-1_261_570_943)
internal val Res.string.operational_overview_expense_planned: StringResource by lazy {
      StringResource("string:operational_overview_expense_planned", "operational_overview_expense_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40126, 68),
      ))
    }

@delegate:ResourceContentHash(2_069_831_774)
internal val Res.string.operational_overview_fopag: StringResource by lazy {
      StringResource("string:operational_overview_fopag", "operational_overview_fopag", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40311, 50),
      ))
    }

@delegate:ResourceContentHash(-1_502_851_098)
internal val Res.string.operational_overview_fopag_percent: StringResource by lazy {
      StringResource("string:operational_overview_fopag_percent", "operational_overview_fopag_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40248, 62),
      ))
    }

@delegate:ResourceContentHash(-842_496_771)
internal val Res.string.operational_overview_legend_expense: StringResource by lazy {
      StringResource("string:operational_overview_legend_expense", "operational_overview_legend_expense", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40362, 63),
      ))
    }

@delegate:ResourceContentHash(-862_941_664)
internal val Res.string.operational_overview_legend_revenue: StringResource by lazy {
      StringResource("string:operational_overview_legend_revenue", "operational_overview_legend_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40426, 67),
      ))
    }

@delegate:ResourceContentHash(531_173_658)
internal val Res.string.operational_overview_monthly_results_title: StringResource by lazy {
      StringResource("string:operational_overview_monthly_results_title", "operational_overview_monthly_results_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40494, 78),
      ))
    }

@delegate:ResourceContentHash(-31_538_723)
internal val Res.string.operational_overview_profitability_axis: StringResource by lazy {
      StringResource("string:operational_overview_profitability_axis", "operational_overview_profitability_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40573, 71),
      ))
    }

@delegate:ResourceContentHash(-672_262_366)
internal val Res.string.operational_overview_profitability_title: StringResource by lazy {
      StringResource("string:operational_overview_profitability_title", "operational_overview_profitability_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40645, 92),
      ))
    }

@delegate:ResourceContentHash(1_048_661_689)
internal val Res.string.operational_overview_result: StringResource by lazy {
      StringResource("string:operational_overview_result", "operational_overview_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40810, 55),
      ))
    }

@delegate:ResourceContentHash(-796_129_649)
internal val Res.string.operational_overview_result_provisioned: StringResource by lazy {
      StringResource("string:operational_overview_result_provisioned", "operational_overview_result_provisioned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40738, 71),
      ))
    }

@delegate:ResourceContentHash(-1_380_451_672)
internal val Res.string.operational_overview_revenue: StringResource by lazy {
      StringResource("string:operational_overview_revenue", "operational_overview_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41171, 52),
      ))
    }

@delegate:ResourceContentHash(1_165_880_054)
internal val Res.string.operational_overview_revenue_expense_axis: StringResource by lazy {
      StringResource("string:operational_overview_revenue_expense_axis", "operational_overview_revenue_expense_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40866, 65),
      ))
    }

@delegate:ResourceContentHash(2_045_031_047)
internal val Res.string.operational_overview_revenue_expense_title: StringResource by lazy {
      StringResource("string:operational_overview_revenue_expense_title", "operational_overview_revenue_expense_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40932, 98),
      ))
    }

@delegate:ResourceContentHash(1_211_127_965)
internal val Res.string.operational_overview_revenue_per_fopag: StringResource by lazy {
      StringResource("string:operational_overview_revenue_per_fopag", "operational_overview_revenue_per_fopag", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41031, 70),
      ))
    }

@delegate:ResourceContentHash(-1_261_570_943)
internal val Res.string.operational_overview_revenue_planned: StringResource by lazy {
      StringResource("string:operational_overview_revenue_planned", "operational_overview_revenue_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41102, 68),
      ))
    }

@delegate:ResourceContentHash(-1_196_100_491)
internal val Res.string.operational_overview_transported: StringResource by lazy {
      StringResource("string:operational_overview_transported", "operational_overview_transported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41224, 64),
      ))
    }

@delegate:ResourceContentHash(1_109_272_369)
internal val Res.string.operational_overview_units_margin_axis: StringResource by lazy {
      StringResource("string:operational_overview_units_margin_axis", "operational_overview_units_margin_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41289, 62),
      ))
    }

@delegate:ResourceContentHash(-862_169_057)
internal val Res.string.operational_overview_units_more: StringResource by lazy {
      StringResource("string:operational_overview_units_more", "operational_overview_units_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41352, 87),
      ))
    }

@delegate:ResourceContentHash(648_185_425)
internal val Res.string.operational_overview_units_negative_more: StringResource by lazy {
      StringResource("string:operational_overview_units_negative_more", "operational_overview_units_negative_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41440, 104),
      ))
    }

@delegate:ResourceContentHash(1_429_003_055)
internal val Res.string.operational_overview_units_negative_title: StringResource by lazy {
      StringResource("string:operational_overview_units_negative_title", "operational_overview_units_negative_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41545, 101),
      ))
    }

@delegate:ResourceContentHash(-1_489_851_214)
internal val Res.string.operational_overview_units_title: StringResource by lazy {
      StringResource("string:operational_overview_units_title", "operational_overview_units_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41647, 96),
      ))
    }

@delegate:ResourceContentHash(-1_486_223_004)
internal val Res.string.operational_panel_title: StringResource by lazy {
      StringResource("string:operational_panel_title", "operational_panel_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41744, 39),
      ))
    }

@delegate:ResourceContentHash(-907_324_324)
internal val Res.string.operational_pdf_title: StringResource by lazy {
      StringResource("string:operational_pdf_title", "operational_pdf_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41784, 65),
      ))
    }

@delegate:ResourceContentHash(1_329_642_000)
internal val Res.string.operational_pending_approvals_title: StringResource by lazy {
      StringResource("string:operational_pending_approvals_title", "operational_pending_approvals_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41850, 99),
      ))
    }

@delegate:ResourceContentHash(863_132_580)
internal val Res.string.operational_pending_drafts_title: StringResource by lazy {
      StringResource("string:operational_pending_drafts_title", "operational_pending_drafts_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41950, 108),
      ))
    }

@delegate:ResourceContentHash(-1_352_724_618)
internal val Res.string.operational_people_col_absent_hours: StringResource by lazy {
      StringResource("string:operational_people_col_absent_hours", "operational_people_col_absent_hours", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42059, 63),
      ))
    }

@delegate:ResourceContentHash(319_668_880)
internal val Res.string.operational_people_col_absenteeism: StringResource by lazy {
      StringResource("string:operational_people_col_absenteeism", "operational_people_col_absenteeism", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42194, 58),
      ))
    }

@delegate:ResourceContentHash(447_690_116)
internal val Res.string.operational_people_col_absenteeism_percent: StringResource by lazy {
      StringResource("string:operational_people_col_absenteeism_percent", "operational_people_col_absenteeism_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42123, 70),
      ))
    }

@delegate:ResourceContentHash(726_484_531)
internal val Res.string.operational_people_col_bonus: StringResource by lazy {
      StringResource("string:operational_people_col_bonus", "operational_people_col_bonus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42253, 44),
      ))
    }

@delegate:ResourceContentHash(2_052_756_597)
internal val Res.string.operational_people_col_effective: StringResource by lazy {
      StringResource("string:operational_people_col_effective", "operational_people_col_effective", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42298, 52),
      ))
    }

@delegate:ResourceContentHash(-1_904_133_488)
internal val Res.string.operational_people_col_employees: StringResource by lazy {
      StringResource("string:operational_people_col_employees", "operational_people_col_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42351, 60),
      ))
    }

@delegate:ResourceContentHash(-1_792_106_357)
internal val Res.string.operational_people_col_hires: StringResource by lazy {
      StringResource("string:operational_people_col_hires", "operational_people_col_hires", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42412, 48),
      ))
    }

@delegate:ResourceContentHash(1_432_657_045)
internal val Res.string.operational_people_col_night_shift: StringResource by lazy {
      StringResource("string:operational_people_col_night_shift", "operational_people_col_night_shift", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42461, 66),
      ))
    }

@delegate:ResourceContentHash(-24_946_278)
internal val Res.string.operational_people_col_overtime: StringResource by lazy {
      StringResource("string:operational_people_col_overtime", "operational_people_col_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42528, 55),
      ))
    }

@delegate:ResourceContentHash(755_076_030)
internal val Res.string.operational_people_col_programmed_hours: StringResource by lazy {
      StringResource("string:operational_people_col_programmed_hours", "operational_people_col_programmed_hours", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42584, 71),
      ))
    }

@delegate:ResourceContentHash(532_340_310)
internal val Res.string.operational_people_col_terminations: StringResource by lazy {
      StringResource("string:operational_people_col_terminations", "operational_people_col_terminations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42656, 55),
      ))
    }

@delegate:ResourceContentHash(1_231_930_251)
internal val Res.string.operational_people_col_turnover: StringResource by lazy {
      StringResource("string:operational_people_col_turnover", "operational_people_col_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42776, 51),
      ))
    }

@delegate:ResourceContentHash(1_095_093_218)
internal val Res.string.operational_people_col_turnover_percent: StringResource by lazy {
      StringResource("string:operational_people_col_turnover_percent", "operational_people_col_turnover_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42712, 63),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.operational_people_col_unit: StringResource by lazy {
      StringResource("string:operational_people_col_unit", "operational_people_col_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42828, 47),
      ))
    }

@delegate:ResourceContentHash(694_572_540)
internal val Res.string.operational_people_empty: StringResource by lazy {
      StringResource("string:operational_people_empty", "operational_people_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42876, 84),
      ))
    }

@delegate:ResourceContentHash(1_341_200_303)
internal val Res.string.operational_people_evolution_absenteeism: StringResource by lazy {
      StringResource("string:operational_people_evolution_absenteeism", "operational_people_evolution_absenteeism", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42961, 84),
      ))
    }

@delegate:ResourceContentHash(-782_780_676)
internal val Res.string.operational_people_evolution_bonus: StringResource by lazy {
      StringResource("string:operational_people_evolution_bonus", "operational_people_evolution_bonus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43046, 70),
      ))
    }

@delegate:ResourceContentHash(719_491_499)
internal val Res.string.operational_people_evolution_overtime: StringResource by lazy {
      StringResource("string:operational_people_evolution_overtime", "operational_people_evolution_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43117, 77),
      ))
    }

@delegate:ResourceContentHash(-1_423_537_977)
internal val Res.string.operational_people_evolution_payroll: StringResource by lazy {
      StringResource("string:operational_people_evolution_payroll", "operational_people_evolution_payroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43280, 72),
      ))
    }

@delegate:ResourceContentHash(-1_558_567_502)
internal val Res.string.operational_people_evolution_payroll_percent: StringResource by lazy {
      StringResource("string:operational_people_evolution_payroll_percent", "operational_people_evolution_payroll_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43195, 84),
      ))
    }

@delegate:ResourceContentHash(-433_417_278)
internal val Res.string.operational_people_evolution_turnover: StringResource by lazy {
      StringResource("string:operational_people_evolution_turnover", "operational_people_evolution_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43353, 77),
      ))
    }

@delegate:ResourceContentHash(319_668_880)
internal val Res.string.operational_people_kpi_absenteeism: StringResource by lazy {
      StringResource("string:operational_people_kpi_absenteeism", "operational_people_kpi_absenteeism", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43431, 58),
      ))
    }

@delegate:ResourceContentHash(726_484_531)
internal val Res.string.operational_people_kpi_bonus: StringResource by lazy {
      StringResource("string:operational_people_kpi_bonus", "operational_people_kpi_bonus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43490, 44),
      ))
    }

@delegate:ResourceContentHash(874_678_865)
internal val Res.string.operational_people_kpi_liquid_payroll: StringResource by lazy {
      StringResource("string:operational_people_kpi_liquid_payroll", "operational_people_kpi_liquid_payroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43535, 53),
      ))
    }

@delegate:ResourceContentHash(-24_946_278)
internal val Res.string.operational_people_kpi_overtime: StringResource by lazy {
      StringResource("string:operational_people_kpi_overtime", "operational_people_kpi_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43589, 55),
      ))
    }

@delegate:ResourceContentHash(1_231_930_251)
internal val Res.string.operational_people_kpi_turnover: StringResource by lazy {
      StringResource("string:operational_people_kpi_turnover", "operational_people_kpi_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43645, 51),
      ))
    }

@delegate:ResourceContentHash(-387_673_511)
internal val Res.string.operational_people_kpi_variable_costs: StringResource by lazy {
      StringResource("string:operational_people_kpi_variable_costs", "operational_people_kpi_variable_costs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43697, 69),
      ))
    }

@delegate:ResourceContentHash(-1_904_133_488)
internal val Res.string.operational_people_legend_employees: StringResource by lazy {
      StringResource("string:operational_people_legend_employees", "operational_people_legend_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43767, 63),
      ))
    }

@delegate:ResourceContentHash(2_117_218_479)
internal val Res.string.operational_people_legend_fopag_variation: StringResource by lazy {
      StringResource("string:operational_people_legend_fopag_variation", "operational_people_legend_fopag_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43831, 77),
      ))
    }

@delegate:ResourceContentHash(-1_792_106_357)
internal val Res.string.operational_people_legend_hires: StringResource by lazy {
      StringResource("string:operational_people_legend_hires", "operational_people_legend_hires", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43909, 51),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("operational_detailed_summary_title", Res.string.operational_detailed_summary_title)
  map.put("operational_detailed_total", Res.string.operational_detailed_total)
  map.put("operational_detailed_total_planned", Res.string.operational_detailed_total_planned)
  map.put("operational_detailed_total_real", Res.string.operational_detailed_total_real)
  map.put("operational_detailed_weekly_title", Res.string.operational_detailed_weekly_title)
  map.put("operational_directors_empty", Res.string.operational_directors_empty)
  map.put("operational_discard_confirm", Res.string.operational_discard_confirm)
  map.put("operational_discard_message", Res.string.operational_discard_message)
  map.put("operational_discard_title", Res.string.operational_discard_title)
  map.put("operational_edit_hint", Res.string.operational_edit_hint)
  map.put("operational_edit_mode", Res.string.operational_edit_mode)
  map.put("operational_edit_window_info", Res.string.operational_edit_window_info)
  map.put("operational_entries_select_unit_required", Res.string.operational_entries_select_unit_required)
  map.put("operational_entries_title", Res.string.operational_entries_title)
  map.put("operational_entries_unit_label", Res.string.operational_entries_unit_label)
  map.put("operational_entries_unit_placeholder", Res.string.operational_entries_unit_placeholder)
  map.put("operational_expense_estivas", Res.string.operational_expense_estivas)
  map.put("operational_expense_gas", Res.string.operational_expense_gas)
  map.put("operational_expense_hortifruti", Res.string.operational_expense_hortifruti)
  map.put("operational_expense_laticinios", Res.string.operational_expense_laticinios)
  map.put("operational_expense_nao_alimentar_central", Res.string.operational_expense_nao_alimentar_central)
  map.put("operational_expense_nao_alimentar_operacao", Res.string.operational_expense_nao_alimentar_operacao)
  map.put("operational_expense_padarias", Res.string.operational_expense_padarias)
  map.put("operational_expense_proteinas", Res.string.operational_expense_proteinas)
  map.put("operational_expense_sucos_bebidas", Res.string.operational_expense_sucos_bebidas)
  map.put("operational_export_success", Res.string.operational_export_success)
  map.put("operational_export_unavailable", Res.string.operational_export_unavailable)
  map.put("operational_history_empty", Res.string.operational_history_empty)
  map.put("operational_history_rejected", Res.string.operational_history_rejected)
  map.put("operational_history_saved", Res.string.operational_history_saved)
  map.put("operational_history_title", Res.string.operational_history_title)
  map.put("operational_launch_gestao_financeira", Res.string.operational_launch_gestao_financeira)
  map.put("operational_launch_provisionados_mes", Res.string.operational_launch_provisionados_mes)
  map.put("operational_launch_reclamacao_cliente", Res.string.operational_launch_reclamacao_cliente)
  map.put("operational_launch_satisfacao_cliente", Res.string.operational_launch_satisfacao_cliente)
  map.put("operational_maintenance_message", Res.string.operational_maintenance_message)
  map.put("operational_managers_col_expense", Res.string.operational_managers_col_expense)
  map.put("operational_managers_col_result", Res.string.operational_managers_col_result)
  map.put("operational_managers_col_revenue", Res.string.operational_managers_col_revenue)
  map.put("operational_managers_empty", Res.string.operational_managers_empty)
  map.put("operational_managers_totals_caption", Res.string.operational_managers_totals_caption)
  map.put("operational_no_company", Res.string.operational_no_company)
  map.put("operational_overview_employees", Res.string.operational_overview_employees)
  map.put("operational_overview_empty", Res.string.operational_overview_empty)
  map.put("operational_overview_expense", Res.string.operational_overview_expense)
  map.put("operational_overview_expense_planned", Res.string.operational_overview_expense_planned)
  map.put("operational_overview_fopag", Res.string.operational_overview_fopag)
  map.put("operational_overview_fopag_percent", Res.string.operational_overview_fopag_percent)
  map.put("operational_overview_legend_expense", Res.string.operational_overview_legend_expense)
  map.put("operational_overview_legend_revenue", Res.string.operational_overview_legend_revenue)
  map.put("operational_overview_monthly_results_title", Res.string.operational_overview_monthly_results_title)
  map.put("operational_overview_profitability_axis", Res.string.operational_overview_profitability_axis)
  map.put("operational_overview_profitability_title", Res.string.operational_overview_profitability_title)
  map.put("operational_overview_result", Res.string.operational_overview_result)
  map.put("operational_overview_result_provisioned", Res.string.operational_overview_result_provisioned)
  map.put("operational_overview_revenue", Res.string.operational_overview_revenue)
  map.put("operational_overview_revenue_expense_axis", Res.string.operational_overview_revenue_expense_axis)
  map.put("operational_overview_revenue_expense_title", Res.string.operational_overview_revenue_expense_title)
  map.put("operational_overview_revenue_per_fopag", Res.string.operational_overview_revenue_per_fopag)
  map.put("operational_overview_revenue_planned", Res.string.operational_overview_revenue_planned)
  map.put("operational_overview_transported", Res.string.operational_overview_transported)
  map.put("operational_overview_units_margin_axis", Res.string.operational_overview_units_margin_axis)
  map.put("operational_overview_units_more", Res.string.operational_overview_units_more)
  map.put("operational_overview_units_negative_more", Res.string.operational_overview_units_negative_more)
  map.put("operational_overview_units_negative_title", Res.string.operational_overview_units_negative_title)
  map.put("operational_overview_units_title", Res.string.operational_overview_units_title)
  map.put("operational_panel_title", Res.string.operational_panel_title)
  map.put("operational_pdf_title", Res.string.operational_pdf_title)
  map.put("operational_pending_approvals_title", Res.string.operational_pending_approvals_title)
  map.put("operational_pending_drafts_title", Res.string.operational_pending_drafts_title)
  map.put("operational_people_col_absent_hours", Res.string.operational_people_col_absent_hours)
  map.put("operational_people_col_absenteeism", Res.string.operational_people_col_absenteeism)
  map.put("operational_people_col_absenteeism_percent", Res.string.operational_people_col_absenteeism_percent)
  map.put("operational_people_col_bonus", Res.string.operational_people_col_bonus)
  map.put("operational_people_col_effective", Res.string.operational_people_col_effective)
  map.put("operational_people_col_employees", Res.string.operational_people_col_employees)
  map.put("operational_people_col_hires", Res.string.operational_people_col_hires)
  map.put("operational_people_col_night_shift", Res.string.operational_people_col_night_shift)
  map.put("operational_people_col_overtime", Res.string.operational_people_col_overtime)
  map.put("operational_people_col_programmed_hours", Res.string.operational_people_col_programmed_hours)
  map.put("operational_people_col_terminations", Res.string.operational_people_col_terminations)
  map.put("operational_people_col_turnover", Res.string.operational_people_col_turnover)
  map.put("operational_people_col_turnover_percent", Res.string.operational_people_col_turnover_percent)
  map.put("operational_people_col_unit", Res.string.operational_people_col_unit)
  map.put("operational_people_empty", Res.string.operational_people_empty)
  map.put("operational_people_evolution_absenteeism", Res.string.operational_people_evolution_absenteeism)
  map.put("operational_people_evolution_bonus", Res.string.operational_people_evolution_bonus)
  map.put("operational_people_evolution_overtime", Res.string.operational_people_evolution_overtime)
  map.put("operational_people_evolution_payroll", Res.string.operational_people_evolution_payroll)
  map.put("operational_people_evolution_payroll_percent", Res.string.operational_people_evolution_payroll_percent)
  map.put("operational_people_evolution_turnover", Res.string.operational_people_evolution_turnover)
  map.put("operational_people_kpi_absenteeism", Res.string.operational_people_kpi_absenteeism)
  map.put("operational_people_kpi_bonus", Res.string.operational_people_kpi_bonus)
  map.put("operational_people_kpi_liquid_payroll", Res.string.operational_people_kpi_liquid_payroll)
  map.put("operational_people_kpi_overtime", Res.string.operational_people_kpi_overtime)
  map.put("operational_people_kpi_turnover", Res.string.operational_people_kpi_turnover)
  map.put("operational_people_kpi_variable_costs", Res.string.operational_people_kpi_variable_costs)
  map.put("operational_people_legend_employees", Res.string.operational_people_legend_employees)
  map.put("operational_people_legend_fopag_variation", Res.string.operational_people_legend_fopag_variation)
  map.put("operational_people_legend_hires", Res.string.operational_people_legend_hires)
}
